export const LIVE_DATA_WARNINGS = Object.freeze({
  DEVICE_METERING_COMPONENT:
    "Device metering could not be loaded. You may proceed, but ensure the device is functioning as expected before continuing.",
  DEVICE_LIVE_METERING_COMPONENT:
    "Live metering could not be loaded. You may proceed, but ensure the device is functioning as expected before continuing.",
});
